// Currency formatting for the business-case overlay.
//
// The portal has no `window.AppLib.formatCurrency`. Per-tenant currency is
// fetched once via `GET /api/portal/tenant` (US1 T1.6) and threaded through the
// `useBusinessCase` hook; this helper turns that ISO-4217 code into a formatter
// backed by `Intl.NumberFormat`. No `window.*` references.

const FIXED_LOCALE = 'en-US';

/** Build an `Intl.NumberFormat`-backed currency formatter for `currency`. */
export function makeCurrencyFormatter(
  currency: string,
): (value: number | null | undefined) => string {
  const safeCurrency = currency && currency.trim() ? currency : 'USD';
  let nf: Intl.NumberFormat;
  try {
    nf = new Intl.NumberFormat(FIXED_LOCALE, {
      style: 'currency',
      currency: safeCurrency,
      maximumFractionDigits: 0,
    });
  } catch {
    // Invalid currency code → fall back to USD so the overlay still renders.
    nf = new Intl.NumberFormat(FIXED_LOCALE, {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0,
    });
  }
  return (value: number | null | undefined): string => {
    const n = typeof value === 'number' && Number.isFinite(value) ? value : 0;
    return nf.format(n);
  };
}
